import script from "./BDinformation.vue?vue&type=script&setup=true&lang=js"
export * from "./BDinformation.vue?vue&type=script&setup=true&lang=js"

import "./BDinformation.vue?vue&type=style&index=0&id=c2ec8700&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ec8700"]])

export default __exports__